import {css, html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../../WebComponent.js'
import '../../../components/Verbrauch/GasConsumptionPlot.js'
import '@isceco/widget-library2/basic-elements/Checkbox/Checkbox.js'
import '@isceco/widget-library2/basic-elements/NumberInput/NumberInput.js'
import ChartService from "../../Verbrauch/Region/ChartService";
import I18n from "../../../i18n"
import AuthorizationFilter from '../../Authorization/AuthorizationFilter.js'

export default class MassnahmenRegion extends WebComponent {

  static KONTINGENTIERUNG_DIALOG = 'massnahmen-kontingentierung-dialog';

  get css() {
    return css`
      isceco-title:first-of-type {
        display: block;
        margin-top: -20px;
      }

      .container {
        display: flex;
        gap: 2em;
        flex-wrap: wrap;
      }

      .diagram {
        width: 70%;
        flex-grow: 2;
      }

      .footer {
        display: flex;
        align-items: center;
        justify-content: center;
        //gap: 10px;
        margin-top: 10px;
      }

      .massnahmen {
        padding-bottom: 10px;
      }

      .row {
        display: flex;
        width: 300px;
        gap: 5px 20px;
        align-items: center;
      }

      .input {
        margin-top: -2px;
        padding-left: 30px;
        width: 80px;
      }

      .input-text {
        width: 160px;
        word-break: normal;
      }

      .js-plotly-plot {
        background-color: var(--isceco-color-white-500);
        box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 4px 0px;
        border-radius: 4px !important;
      }
    `
  }

  get translationFile() {
    return './views/Massnahmen/Region/i18n.json'
  }

  constructor() {
    super()
    this.chartService = new ChartService()
    this.startDate = this.addDays(new Date(), -14);
    this.endDate = this.addDays(new Date(), +13);
    this.startDateString = this.startDate.toISOString().split('T')[0];
    this.endDateString = this.endDate.toISOString().split('T')[0];
    this.zweiStoff = {typ: 'zweiStoff', checkbox: false}
    this.verbrauchsbeschraenkung = {typ: 'verbrauchsbeschraenkung', checkbox: false, prozent: 0}
    this.kontingentierung = {typ: 'kontingentierung', checkbox: false, d0: null, d1: null, d2: null, d3: null, d4: null, d5: null}
    this.massnahmen = []
    this.gasConsumption = []
    this.temperature = []
    this.gasConsumptionPrognose = []
    this.gebKapazitaet = []
    this.angebot = []
    this.regAngebot = []
    this.nomKapazitaet = []
    this.gasConsumptionPrognoseMitMassnahmen = []
    this.region = this.getAttribute('region');
  }

  connectedCallback() {
    super.connectedCallback()
    document.addEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this.render)

    this.getData();
  }

  disconnectedCallback() {
    document.removeEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this.render)
  }

  getData() {
    Promise.all([this.chartService.getTemperatur(this.region, this.startDateString, this.endDateString),
      this.chartService.getVerbrauch(this.region, this.startDateString, this.endDateString),
      this.chartService.getVerbrauchPrognose(this.region, this.startDateString, this.endDateString),
      this.chartService.getGebuchteKapazitaet(this.region, this.startDateString, this.endDateString),
      this.chartService.getAngebot(this.region, this.startDateString, this.endDateString),
      this.chartService.getRegAngebot(this.region, this.startDateString, this.endDateString),
      this.chartService.getNominierteKapazitaet(this.region, this.startDateString, this.endDateString)
    ])
      .then(([temperature, gasConsumption, gasConsumptionPrognose,
               gebKapazitaet, angebot, regAngebot, nomKapazitaet]) => {
        this.dates = temperature.map(a => a.date);
        this.temperature = temperature.map(a => a.value)
        this.gasConsumption = gasConsumption.map(a => a.value / 1000)
        this.gasConsumptionPrognose = gasConsumptionPrognose.map(a => a.value / 1000)
        this.gebKapazitaet = gebKapazitaet.map(a => a.value / 1000)
        this.angebot = angebot.map(a => a.value / 1000)
        this.regAngebot = regAngebot.map(a => a.value / 1000)
        this.nomKapazitaet = nomKapazitaet.map(a => a.value / 1000000)
        this.render()
      }).catch(_ => this.reload())
  }

  getTemplate() {
    return html`
      <isceco-title
        id="page-title"
        text="${this.i18n.translate(`gas.massnahmen.${this.region}.title`)}"
      ></isceco-title>
      <div class="container">
        <div class="diagram">
          <gas-verbrauch-plot
            id="plotmassnahmen${this.region}"
            .i18n="${this.i18n}"
            source="massnahmen"
            region="${this.region}"
            .dates="${this.dates}"
            .temperature="${this.temperature}"
            .gasConsumption="${this.gasConsumption}"
            .gasConsumptionPrognose="${this.gasConsumptionPrognose}"
            .gebKapazitaet="${this.gebKapazitaet}"
            .angebot="${this.angebot}"
            .regAngebot="${this.regAngebot}"
            .nomKapazitaet="${this.nomKapazitaet}"
            .gasConsumptionPrognoseMitMassnahmen="${this.gasConsumptionPrognoseMitMassnahmen}"
          ></gas-verbrauch-plot>
          <div class="footer">
            ${AuthorizationFilter._hasRoleAdmin() ? html`
              <isceco-button id="export" variant="secondary" size="small" icon="download" style="margin-left: auto;"
                             .hidden="${AuthorizationFilter._hasRoleAdmin()}"
                             @click="${_ => {
                               // Merging arrays into a single array of objects
                               const mergedData = this.dates.map((date, index) => ({
                                 date,
                                 temperature: this.temperature[index],
                                 gasConsumption: this.gasConsumption[index],
                                 gasConsumptionPrognose: this.gasConsumptionPrognose[index],
                                 gebKapazitaet: this.gebKapazitaet[index],
                                 angebot: this.angebot[index],
                                 nomKapazitaet: this.nomKapazitaet[index],
                                 gasConsumptionPrognoseMitMassnahmen: this.gasConsumptionPrognoseMitMassnahmen[index]
                               }));
                               this.exportToCSV(mergedData, 'export_region_' + this.region)
                             }}"
              ></isceco-button>
            ` : html``}
          </div>
        </div>
        <div class="massnahmen">
          <isceco-checkbox
            id="zweistoff-checkbox"
            label="${this.i18n.translate('gas.massnahmen.massnahme.zweistoff')}"
            @change="${e => { this.updateValue('zweiStoff', 'checkbox', e);
              this.render()
            }}"
          ></isceco-checkbox>
          <isceco-checkbox
            id="verbrauchsbeschraenkung-checkbox"
            label="${this.i18n.translate('gas.massnahmen.massnahme.verbrauchsbeschraenkung')}"
            ?value="${this.verbrauchsbeschraenkung.checkbox === true}"
            ?disabled="${this.isVerbrauchsbeschraenkungDisabled()}"
            @change="${e => {
              this.updateValue('verbrauchsbeschraenkung', 'checkbox', e);
              this.render()
            }}"
          ></isceco-checkbox>
          <div class="row">
            <div class="input">
              <isceco-number-input
                id="verbrauchsbeschraenkung-prozent"
                min="0"
                max="100"
                value="${this.verbrauchsbeschraenkung.prozent}"
                ?disabled="${this.isVerbrauchsbeschraenkungDisabled()}"
                @change="${e => this.updateValue('verbrauchsbeschraenkung', 'prozent', e)}"
              ></isceco-number-input>
            </div>
            <div class="input-text">${this.i18n.translate('gas.massnahmen.massnahme.verbrauchsbeschraenkung.effekt')}
            </div>
          </div>
          ${this.renderKontingentierung()}
        </div>
      </div>
    `
  }

  renderKontingentierung() {
    if (this.region === 'chot') {
      return html``
    } else {
      return html`
        <isceco-checkbox
            id="kontingentierung-checkbox"
            label="${this.i18n.translate('gas.massnahmen.massnahme.kontingentierung')}"
            ?value="${this.kontingentierung.checkbox === true}"
            ?disabled="${this.isKontingentierungDisabled()}"
            @change="${e => this.updateValue('kontingentierung', 'checkbox', e)}"
          ></isceco-checkbox>
          ${this.renderKontingentierungNumberInputs()}
          <isceco-button
            style="padding-top: 20px"
            text="${this.i18n.translate('gas.massnahmen.massnahme.kontingentierung.berechnen')}"
            variant="secondary"
            ?disabled="${this.isKontingentierungDisabled()}"
            @click="${_ => this.calcKontingentierungsfaktor()}">
          </isceco-button>
          <isceco-dialog
            id="${MassnahmenRegion.KONTINGENTIERUNG_DIALOG}"
            hidden
            header="${this.i18n.translate('gas.massnahmen.massnahme.kontingentierung.dialog.title')}"
            confirm-button="OK"
            @submit="${e => e.target.setAttribute('hidden', '')}"
          ></isceco-dialog>
      `
    }
  }

  renderKontingentierungNumberInputs() {
    return Array.from({length: 7}).fill().map((_, i) => {
      return html`
        <div class="row">
          <div class="input">
            <isceco-number-input
              id="kontingentierung-prozent-d${i}"
              min="0"
              max="100"
              maximum-fraction-digits="0"
              ?disabled="${this.isKontingentierungDisabled()}"
              @change="${e => this.updateValue('kontingentierung', 'd' + i, e)}"
            ></isceco-number-input>
          </div>
          <div class="input-text">
            ${this.i18n.translate('gas.massnahmen.massnahme.kontingentierung.d' + i)}
          </div>
        </div>
      `
    })
  }

  isVerbrauchsbeschraenkungDisabled() {
    if (this.zweiStoff.checkbox === true) {
      return false
    } else {
      this.verbrauchsbeschraenkung.checkbox = false
      return true
    }
  }

  isKontingentierungDisabled() {
    if (this.zweiStoff.checkbox === true && this.verbrauchsbeschraenkung.checkbox === true) {
      return false
    } else {
      this.kontingentierung.checkbox = false
      return true
    }
  }

  addDays(date, days) {
    date.setDate(date.getDate() + days);
    return date;
  }

  updateValue(key, input, event) {
    this[key][input] = isEmpty(event.detail.value) ? null : event.detail.value;
    if (input === 'checkbox') {
      this.updateMassnahmen(key, event.detail.value)
    }

    this.updateChart()
  }

  updateMassnahmen(key, value) {
    if (value === true) {
      this.massnahmen.push(this[key])
    } else {
      this.massnahmen = this.massnahmen.filter(function (obj) {
        return obj.typ !== key;
      });
    }
  }

  updateChart() {
    this.chartService.getVerbrauchPrognoseMitMassnahmen(this.massnahmen, this.region, this.startDateString, this.endDateString)
      .then(data => {
        this.gasConsumptionPrognoseMitMassnahmen = data.map(a => {
          // Die Daten aus der Vergangenheit werden nur für Schweiz ohne Südtessin angezeigt
          if (this.region !== 'chot' && new Date(a.date).getTime() < new Date().setHours(0, 0, 0, 0)) {
            return NaN
          } else {
            return a.value / 1000
          }
        })
        this.render()
      })
      .catch(_ => {
        showAlert(this.i18n.translate('admin.kundensegmentierung.createupdate.failure'), '', 'error')
        this.render()
      })
  }

  calcKontingentierungsfaktor() {
    // Remove Kontingentierung
    const kfMassnahmen = this.massnahmen.filter(function (obj) {
      return obj.typ !== 'kontingentierung';
    });
    this.chartService.calcKontingentierungsfaktor(kfMassnahmen, this.region, new Date().toISOString().split('T')[0])
      .then(data => {
        const dialog = document.getElementById(MassnahmenRegion.KONTINGENTIERUNG_DIALOG);
        dialog.description = this.renderFaktorTable(data)
        dialog.removeAttribute('hidden')
      })
      .catch(_ => {
        showAlert(this.i18n.translate('admin.kundensegmentierung.createupdate.failure'), '', 'error')
        this.render()
      })
  }

  renderFaktorTable(data) {
    return html`
      <table>${data.map((a, i) => this.renderFaktorRow(i, a.value))}</table>
      ${this.i18n.translate('gas.massnahmen.massnahme.kontingentierung.dialog.berechnet')}:
      ${formatDateTime(new Date())} // ${this.displayName()}`
  }

  renderFaktorRow(i, value) {
    return html`
      <tr>
        <td style="padding-right: 10px">${this.i18n.translate('gas.massnahmen.massnahme.kontingentierung.dialog.d' + i)}
        </td>
        <td>=</td>
        <td style="padding-left: 10px; text-align: right">${this.formatValue(value)}
        </td>
      </tr>`
  }

  formatValue(value) {
    if (value > 100) {
      return this.i18n.translate('gas.massnahmen.massnahme.kontingentierung.dialog.value.over100')
    } else if (value < 0) {
      return this.i18n.translate('gas.massnahmen.massnahme.kontingentierung.dialog.value.negativ')
    } else {
      return value.toLocaleString(undefined, {maximumFractionDigits: 2})
    }
  }

  displayName = () => {
    if (!isEmpty(window.keycloak)) {
      return `${window.keycloak.tokenParsed.given_name} ${window.keycloak.tokenParsed.family_name}`
    } else {
      return ''
    }
  }

  exportToCSV(data, filename = 'VerbrauchMassnahmenRegion.csv') {
    // Define the title and column names
    const title = this.i18n.translate(`gas.massnahmen.${this.region}.title`).replaceAll(', ', '/')
    const columnNames = [
      this.i18n.translate(`gas.massnahmen.datum`),
      this.i18n.translate(`gas.massnahmen.temperatur`),
      this.i18n.translate(`gas.massnahmen.verbrauch`),
      this.i18n.translate(`gas.massnahmen.prog.verbrauch`),
      this.i18n.translate(`gas.massnahmen.geb.kapa`),
      this.i18n.translate(`gas.massnahmen.angebot`),
      this.i18n.translate(`gas.massnahmen.nom.kapa`),
      this.i18n.translate(`gas.massnahmen.prog.verbrauch.mass`)
    ]
    // Create the CSV content
    const csvContent = [
      title,
      columnNames.join(','),
      ...data.map(row => Object.values(row).join(','))
    ].join('\n')
    // Create a Blob from the CSV content
    const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'})
    // Create a link element
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    // Set the link's attributes
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    // Append the link to the document
    document.body.appendChild(link);
    // Programmatically click the link to trigger the download
    link.click()
    // Clean up
    document.body.removeChild(link)
  }
}
customElements.define('gasmonitoring-frontend-massnahmen-region', MassnahmenRegion)
